<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">
      <div>
        <section id="scroll-dynamic">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">

                  <h4 class="form-section"><i class="ft-user"></i> Enroll User Templates</h4>
                  <hr>
                  <br>
                  <form class="form form-horizontal">
                    <div class="form-body">

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group row">
                            <label class="col-md-1 label-control" for="userinput5">Device : </label>
                            <div class="col-md-3">
                              <select (change)="selectChangeHandlerDeviceFrom($event)"
                                class="browser-default custom-select">
                                <option selected>Select Device</option>
                                <option *ngFor="let item of Device" value="{{item.device_id}}">{{item.deviceName}}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-2">
                              <div class="float-right">
                                <button class="btn btn-primary" (click)='DownloadTemplates()' >Download </button>
                              </div>
                            </div>


                          </div>
                        </div>




                      </div>
                    </div>
                  </form>


                </div>
                <div class="card-content" *ngIf="dataTable">
                  <div class="card-body card-dashboard table-responsive">

                    <table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered file-export">
                      <thead>
                        <tr>


                          <th>User ID</th>
                          <th>Name</th>
                          <th>Priviledge</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of UserTemplates">

                          <td>{{item.userId}}</td>
                          <td>{{item.userName}}</td>
                          <td>{{item.userPrivilledge}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>



              </div>
            </div>
          </div>
        </section>
      </div>

    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
